export default "__VITE_ASSET__01723f06__"